import chroma from 'chroma-js';

export const getLightenedColors = (color: string) => {
  const chromaColor = chroma(color);
  return {
    color100: chromaColor,
    color90: chromaColor.mix('white', 0.1),
    color75: chromaColor.mix('white', 0.25),
    color50: chromaColor.mix('white', 0.5),
    color25: chromaColor.mix('white', 0.75),
    color10: chromaColor.mix('white', 0.9),
  };
};

interface PortalCssOptions {
  primaryColor: string;
  secondaryColor: string;
  logoHeightMobile?: string;
  logoHeightDesktop?: string;
}

export const getPortalCss = (options: PortalCssOptions) => {
  const { primaryColor, secondaryColor, logoHeightMobile, logoHeightDesktop } = options;
  const primaryColors = getLightenedColors(primaryColor);
  return (
    <style type="text/css">
      {`
        :root {
          --primary-color: ${primaryColors.color100};
          --primary-color-90: ${primaryColors.color90};
          --primary-color-75: ${primaryColors.color75};
          --primary-color-50: ${primaryColors.color50};
          --primary-color-25: ${primaryColors.color25};
          --primary-color-10: ${primaryColors.color10};
          --secondary-color: ${secondaryColor};
          ${logoHeightMobile ? `--logo-height-mobile: ${logoHeightMobile};` : ''}
          ${logoHeightDesktop ? `--logo-height-desktop: ${logoHeightDesktop};` : ''}
        }
      `}
    </style>
  );
};
